import { Helmet } from "react-helmet-async";
import { SITE } from "../data/site";

export default function Seo({ title, description, path = "/", image, jsonLd, noindex = false }) {
  const url = `${SITE.url}${path}`;
  const ogImage = image ? `${SITE.url}${image}` : SITE.defaultOgImage;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Global Industry Group, Inc.",
  url: "https://www.globalindg.com/",
  logo: "https://www.globalindg.com/assets/global-industry-group-logo.webp",
  telephone: "+1-281-607-1002",
  email: "Sales@Globalindg.com",
  address: [
    {
      "@type": "PostalAddress",
      streetAddress: "3129 Kingsley Drive, Suite 520",
      addressLocality: "Pearland",
      addressRegion: "TX",
      postalCode: "77584",
      addressCountry: "US",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "1910 Pacific Avenue, Suite 2000",
      addressLocality: "Dallas",
      addressRegion: "TX",
      postalCode: "75201",
      addressCountry: "US",
    },
  ],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Global Industry Group, Inc.",
  url: "https://www.globalindg.com/",
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `https://www.globalindg.com${it.path}`,
  })),
});
